import bemify from '../../utils/bemUtils';
import Component from '../component/component';
import Rest from '../../rest';

class FacilityLookup extends Component {
    #makeModelsDropdownRef = null;
    #dateInputRef = null;
    #feesRef = null;
    #fboFee = null;
    #fbo = null;

    get AirportCode() {
        return this.getAttribute('airport-code') ?? '';
    }

    get CityValue() {
        return this.getAttribute('city-value') ?? '';
    }

    get StateValue() {
        return this.getAttribute('state-value') ?? '';
    }

    initTemplate() {
        const [block, element] = bemify('facility-lookup');
        const template = document.createElement('template');

        template.innerHTML = `
        <style>
            @import url('${process.env.APP_CSS_PATH}');
        </style>

        <section id="${block()}" class="${element('container')}">
            <p class="${element('title', null)}">View Pricing</p>
            <p class="${element('padded-text')}">${this.AirportCode} - ${this.CityValue}, ${this.StateValue}</p>
            <p class="${element('padded-text')}">To view pricing, type your make and model to select your aircraft and choose arrival date.</p>
            <div class="${element('row')}">
                <div class="form__group ${element('column')}">
                    <sk-autocomplete id="${element('make-model-dropdown')}"
                                 placeholder="Make & Model">
                    </sk-autocomplete>
                    <span class="form__required-message">Make & Model is required</span>
                </div>

                <div class="form__group ${element('s-column')}">
                    <input id="${element('date-input')}" class="date-input" type="date" min="${new Date()
                .toISOString()
                .slice(0, 10)}" />
                    <span class="form__invalid-message">Arrival Date must be today or greater</span>
                    <span class="form__required-message">Arrival Date is required</span>
                </div>
            </div>

            <div id="facility-lookup__disclaimer" class="${element('disclaimer')}">
                **Rates provided can vary by date of arrival or aircraft type,
                do not reflect specific customer discounts or airport mandated concessions or fees,
                where applicable, and are subject to change.
            </div>

            <div id="${element('fees')}" class="${element('row')}">
            </div>
        </section>
        `;

        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.appendChild(template.content.cloneNode(true));
    }

    onMounted() {
        this.#makeModelsDropdownRef = this.shadowRoot.getElementById('facility-lookup__make-model-dropdown');
        this.#dateInputRef = this.shadowRoot.getElementById('facility-lookup__date-input');
        this.#feesRef = this.shadowRoot.getElementById('facility-lookup__fees');

        Rest.get(`${process.env.API_MAKE_MODELS}/GetAll`).then(async data => {
            if (!data) return;

            const makeModels = await data.text();
            this.#makeModelsDropdownRef.items = makeModels;
        });

        Rest.get(`${process.env.API_FBO}/Get?AirportCode=${this.AirportCode}`).then(async data => {
            if (!data) return;

            this.#fbo = await data.json();
        });

        this.#makeModelsDropdownRef.addEventListener('on-before-close', e => {
            const dropdownItems = e.detail;

            if (dropdownItems) {
                dropdownItems.classList.remove('dropdown__items--no-absolute');
            }
        });

        const autocompleteInput = this.#makeModelsDropdownRef.shadowRoot.querySelector('.autocomplete__input');
        if (autocompleteInput) {
            autocompleteInput.addEventListener('input', () => {
                if (!autocompleteInput.value || autocompleteInput.value.trim() === '') {
                    this.#fboFee = null;
                    this.#feesRef.innerHTML = '';
                    this.#makeModelsDropdownRef.value = '';
                    this.#getFees();
                }
            });
        }

        this.#makeModelsDropdownRef.addEventListener('on-change', e => {
        const { reason } = e.detail;

        if (reason === 'itemSelected') {
            if (e) {
                e.stopPropagation();
            }

            if (!this.#makeModelsDropdownRef.displayedValue || this.#makeModelsDropdownRef.displayedValue.trim() === '') {
                this.#showErrorMessage(this.#makeModelsDropdownRef, this.#makeModelsDropdownRef.parentNode, 'form__required-message', 'form__required-message--visible');
                return;
            }

            if (this.#makeModelsDropdownRef.value?.length > 0 && this.#makeModelsDropdownRef.value !== 'undefined') {
                this.#clearFieldErrors(this.#makeModelsDropdownRef);
                this.#getFees();
            }
        } else if (reason === 'cleared') {
            this.#fboFee = null;
            this.#feesRef.innerHTML = '';
        }
    });

        this.#dateInputRef.addEventListener('change', () => {
            if (this.#dateInputRef.value?.length >= 0 && this.#dateInputRef.value !== 'undefined') {
                this.#clearFieldErrors(this.#dateInputRef);
                this.#getFees();
            }
        }
        );
    }

    render() {
        const [_, element] = bemify('facility-lookup');
        this.#feesRef.innerHTML = '';
        const dollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
        });

        if (!this.#fboFee) return;

        let noFeesToShow = true;
        let feeCount = 0;
        const waivePercent = `${Intl.NumberFormat('en-US', { style: 'percent' }).format(this.#fboFee.maxFacFeeWaivePercent)} `;

      if (this.#fboFee.facFeeAmounts.length > 0) {
        noFeesToShow = false;
        feeCount++;
          this.#feesRef.innerHTML += `
          <div class="${element('fee')}" span-col="2">
              <h4 class="${element('label', null)}">${this.#fboFee.facilityFee.comment}</h4>
              <div class="${element('text')}">${
                this.#fboFee.facFeeAmounts.length > 1
                  ? 'Please contact base.'
                  : `<p>${dollar.format(
                      this.#fboFee.facilityFee.unitPrice
                    )}</p><p>${dollar.format(this.#fboFee.facFeeAmounts[0].facFeeAmount)} with ${
                      this.#fboFee.facFeeAmounts[0].beginGals
                  } gallons or more</p>`
              }</div>
          </div>
          `;
      } else if (this.#fboFee.facilityFee?.unitPrice > 0) {
        noFeesToShow = false;
        feeCount++;
          this.#feesRef.innerHTML += `
          <div class="${element('fee')}">
              <h4 class="${element('label', null)}">${this.#fboFee.facilityFee.comment}</h4>
              <p class="${element('text')}">${dollar.format(this.#fboFee.facilityFee.unitPrice)}</p>
          </div>
          `;

          if (this.#fboFee.maxFacFeeWaivePercent != 0) {
              if (
                  (((this.#fboFee.fuelProductId == 1 || this.#fboFee.isMultiFuelAircraft) && this.#fboFee.isJetAOffered) || // JETA = 1
                      (this.#fboFee.fuelProductId == 2 && !this.#fboFee.isMultiFuelAircraft && this.#fboFee.is100LLOffered))
              ) {
                  noFeesToShow = false;
                  feeCount++;
                  // 100LL = 2
                  this.#feesRef.innerHTML += `
              <div class="${element('fee')}">
                  <h4 class="${element('label', null)}">Gallons Needed to Waive ${this.#fboFee.maxFacFeeWaivePercent < 1 ? waivePercent : ''}${this.#fboFee.facilityFee.comment}</h4>
                  <p class="${element('text')}">${this.#fboFee.gallonsToWaive.unitPrice <= 0
                          ? 'Please contact base'
                          : this.#fboFee.gallonsToWaive.unitPrice
                      }</p>
              </div>
              `;
              } else if (this.#fboFee.facilityFee?.unitPrice > 0) {
                  noFeesToShow = false;
                  feeCount++;
                  this.#feesRef.innerHTML += `
              <div class="${element('fee')}">
                  <h4 class="${element('label', null)}">Gallons Needed to Waive ${this.#fboFee.maxFacFeeWaivePercent < 1 ? waivePercent : ''}${this.#fboFee.facilityFee.comment}</h4>
                  <p class="${element('text')}">${this.#fbo
                          ? `Please contact the base directly at <a href="tel: ${this.#fbo.phone}">${this.#fbo.phone
                          }</a> for further information.`
                          : 'Please contact the base directly for further information.'
                      }</p>
              </div>
              `;
              }
          }

      }

      if (!this.#feesRef.isMultiFuelAircraft && this.#fboFee.habitatFee?.unitPrice > 0) {
        noFeesToShow = false;
        feeCount++;
          this.#feesRef.innerHTML += `
          <div class="${element('fee')}">
              <h4 class="${element('label', null)}">${this.#fboFee.habitatFee.comment}</h4>
              <p class="${element('text')}">${dollar.format(this.#fboFee.habitatFee.unitPrice)}</p>
          </div>
          `;
      }

      if (this.#fboFee.specialEventFee?.unitPrice > 0) {
        noFeesToShow = false;
        feeCount++;
        this.#feesRef.innerHTML += `
              <div class="${element('fee')}">
                  <h4 class="${element('label', null)}">${this.#fboFee.specialEventFee.comment}</h4>
                  <p class="${element('text')}">${dollar.format(this.#fboFee.specialEventFee.unitPrice)}</p>
              </div>
              `;
      }

      if (this.#fboFee.hasHourlyParking) {

        if (feeCount % 2 != 0) {
          if (this.#fboFee.securityFee?.unitPrice > 0) {
            noFeesToShow = false;
            this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                <h4 class="${element('label', null)}">${this.#fboFee.securityFee.comment}</h4>
                <p class="${element('text')}">${dollar.format(this.#fboFee.securityFee.unitPrice)}</p>
            </div>
            `;
          }
        }

        if (this.#fboFee.hourlyHangarMessage.length > 0) {
          noFeesToShow = false;
          this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                <h4 class="${element('label', null)}">${this.#fboFee.hourlyHangar?.comment ?? 'Hangar'}</h4>
                <p class="${element('text')}">${this.#fboFee.hourlyHangarMessage}</p>
            </div>
            `;
        }

        if (feeCount % 2 == 0) {
          if (this.#fboFee.securityFee?.unitPrice > 0) {
            noFeesToShow = false;
            this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                <h4 class="${element('label', null)}">${this.#fboFee.securityFee.comment}</h4>
                <p class="${element('text')}">${dollar.format(this.#fboFee.securityFee.unitPrice)}</p>
            </div>
            `;
          }
        }

        if (this.#fboFee.hourlyParkingMessage.length > 0) {
          noFeesToShow = false;
          this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                 <h4 class="${element('label', null)}">${this.#fboFee.regularHourlyParking?.comment ?? this.#fboFee.extendedHourlyParking?.comment ?? 'Parking'}</h4>
                <p class="${element('text')}">${this.#fboFee.hourlyParkingMessage}</p>
            </div>
            `;
        }

      }
      else {
        if (this.#fboFee.securityFee?.unitPrice > 0) {
          noFeesToShow = false;
          this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                <h4 class="${element('label', null)}">${this.#fboFee.securityFee.comment}</h4>
                <p class="${element('text')}">${dollar.format(this.#fboFee.securityFee.unitPrice)}</p>
            </div>
            `;
        }

        if (this.#fboFee.parking?.unitPrice > 0 && this.AirportCode.toUpperCase() != '6N5') {
          noFeesToShow = false;
          this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                <h4 class="${element('label', null)}">${this.#fboFee.parking.comment}</h4>
                <p class="${element('text')}">${dollar.format(this.#fboFee.parking.unitPrice)}</p>
            </div>
            `;
        }

        if (this.#fboFee.hangar?.unitPrice > 0) {
          noFeesToShow = false;
          this.#feesRef.innerHTML += `
            <div class="${element('fee')}">
                <h4 class="${element('label', null)}">${this.#fboFee.hangar.comment}</h4>
                <p class="${element('text')}">${dollar.format(this.#fboFee.hangar.unitPrice)}</p>
            </div>
            `;
        }
      }


        if (noFeesToShow) {
            this.#feesRef.innerHTML += `
            <div>
                <p class="${element('text', null)}">${this.#fbo
                    ? `Details are not available for aircraft and date selected. Please call us directly at <a href="tel: ${this.#fbo.phone}">${this.#fbo.phone
                    }</a> for more information.`
                    : 'Details are not available for aircraft and date selected.Please call the base for more information.'
                }</p>
            </div>
            `;
        }

        this.#feesRef.classList.add('facility-lookup__fee-row');
    }

    #clearFieldErrors(field) {
        const requiredMessage = field.parentNode.querySelector('.form__required-message--visible');
        const invalidMessage = field.parentNode.querySelector('.form__invalid-message--visible');

        if (requiredMessage) requiredMessage.classList.remove('form__required-message--visible');
        if (invalidMessage) invalidMessage.classList.remove('form__invalid-message--visible');
    };

    #clearErrors() {
        const requiredMessages = document.querySelectorAll('.form__required-message');

        for (let index = 0; index < requiredMessages?.length; ++index) {
            const requiredMessage = requiredMessages[index];

            if (requiredMessage) {
                requiredMessage.classList.remove('form__required-message--visible');
            }
        }

        const invalidMessages = document.querySelectorAll('.form__invalid-message');

        for (let index = 0; index < invalidMessages?.length; ++index) {
            const invalidMessage = invalidMessages[index];

            if (invalidMessage) {
                invalidMessage.classList.remove('form__invalid-message--visible');
            }
        }
    };

    #showErrorMessage(field, group, errorClass, errorClassVisible, shouldFocus = true) {
        const errorMessage = group?.querySelector(`.${errorClass}`);

        if (errorMessage) {
            field.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'start'
            });
            if (shouldFocus) field.focus();
            errorMessage.classList.add(errorClassVisible);
        }
    };

    #validate() {
        this.#clearErrors();

        let hasErrors = false;

        if (!this.AirportCode) {
            hasErrors = true;
        }

        if (this.#dateInputRef.value?.length <= 0 || this.#dateInputRef.value === 'undefined') {
            hasErrors = true;
            this.#showErrorMessage(
                this.#dateInputRef,
                this.#dateInputRef.parentElement,
                'form__required-message',
                'form__required-message--visible',
                false
            );
            this.#fboFee = null;
            this.render();
        } else {
            const now = new Date();
            now.setHours(0, 0, 0, 0);

            const dateInput = new Date(`${this.#dateInputRef.value}T00:00`);
            dateInput.setHours(0, 0, 0, 0);

            if (dateInput < now) {
                hasErrors = true;
                this.#showErrorMessage(
                    this.#dateInputRef,
                    this.#dateInputRef.parentElement,
                    'form__invalid-message',
                    'form__invalid-message--visible',
                    false
                );
                this.#fboFee = null;
                this.render();
            }
        }

     if (this.#makeModelsDropdownRef.value?.length <= 0 || this.#makeModelsDropdownRef.value === 'undefined') {
            hasErrors = true;
            this.#showErrorMessage(
                this.#makeModelsDropdownRef,
                this.#makeModelsDropdownRef.parentElement,
                'form__required-message',
                'form__required-message--visible'
            );
     }

     if (!this.#makeModelsDropdownRef.displayedValue || this.#makeModelsDropdownRef.displayedValue.trim() === '') {
        hasErrors = true;
        this.#showErrorMessage(
            this.#makeModelsDropdownRef,
            this.#makeModelsDropdownRef.parentElement,
            'form__required-message',
            'form__required-message--visible'
        );
        this.#fboFee = null;
        this.#feesRef.innerHTML = '';
        this.#makeModelsDropdownRef.value = '';
     }

        return !hasErrors;
    };

    async #getFees() {
        if (!this.#validate()) {
            return;
        }

        const response = await Rest.get(
      `${process.env.API_FACILITY_LOOKUP}/Get?aiportCode=${this.AirportCode}&makeModelid=${
        this.#makeModelsDropdownRef.value
      }&arrivalDate=${this.#dateInputRef.value}`
        );
      this.#fboFee = await response.json();
        this.render();
    }
}

customElements.define('sk-facility-lookup', FacilityLookup);

export default FacilityLookup;
